import request from "@/utils/request";

export function baseGpsList(query) {
  return request({
    url: "/ntocc-basic-api/baseGps",
    method: "get",
    params: query
  });
}

export function selectEtcOrderReport(query) {
  return request({
    url: "/ntocc-tms-api/etc/selectEtcOrderReport",
    method: "post",
    params: query
  });
}

// /ntocc-basic-api/baseGps/bindVehicle 绑定车辆
export function bindVehicle(query) {
  return request({
    url: "/ntocc-basic-api/baseGps/bindVehicle",
    method: "post",
    data: query
  });
}

export function unbindVehicle(query) {
  return request({
    url: "/ntocc-basic-api/baseGps/unbindVehicle",
    method: "get",
    params: query
  });
}

// 通过gpsNo查询G7平台历史轨迹
export function historyTrackByGpsNo(query) {
  return request({
    url: "/ntocc-basic-api/baseGps/historyTrackByGpsNo",
    method: "get",
    params: query
  });
}
